// 图表组件配置（远期房态及通用图表设置）
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UNIFIED_TOOLTIP_STYLE, tooltipLine } from '../../../configs/tooltipCommon';
function getWeekdayLabel(dateStr) {
    if (!dateStr)
        return '';
    var d = new Date(dateStr + 'T12:00:00');
    var weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    return weekdays[d.getDay()];
}
function formatTooltipDateHeader(axisValue) {
    if (!axisValue)
        return '';
    var s = String(axisValue).trim();
    var year = new Date().getFullYear();
    var mSlashD = /^(\d{1,2})\/(\d{1,2})$/.exec(s);
    if (mSlashD) {
        var month = Number.parseInt(mSlashD[1], 10);
        var day = Number.parseInt(mSlashD[2], 10);
        var d = new Date(year, month - 1, day);
        var weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        return "".concat(month, "\u6708").concat(day, "\u65E5").concat(weekdays[d.getDay()]);
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        var d = new Date(s + 'T12:00:00');
        var weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        return "".concat(d.getMonth() + 1, "\u6708").concat(d.getDate(), "\u65E5").concat(weekdays[d.getDay()]);
    }
    if (/^\d{1,2}月$/.test(s))
        return s;
    return s;
}
export var COMMON_CHART_SETTINGS = {
    grid: { left: 60, right: 68, top: 24, bottom: 0 },
    barWidth: 24,
    barCategoryGap: '30%',
    barGap: '20%',
    tooltip: __assign(__assign({}, UNIFIED_TOOLTIP_STYLE), { position: function (point, params, dom, rect, size) {
            if (!rect)
                return [point[0] + 10, point[1] - 120];
            var tooltipHeight = (size === null || size === void 0 ? void 0 : size.contentSize) ? size.contentSize[1] : (dom ? dom.offsetHeight : 100);
            var tooltipWidth = (size === null || size === void 0 ? void 0 : size.contentSize) ? size.contentSize[0] : (dom ? dom.offsetWidth : 150);
            var y = point[1] - 40;
            var x = point[0] + 10;
            if (x + tooltipWidth > rect.x + rect.width)
                x = point[0] - tooltipWidth - 10;
            if (x < rect.x)
                x = rect.x + 10;
            var finalY = y;
            if (y < rect.y)
                finalY = rect.y + 10;
            else if (y + tooltipHeight > rect.y + rect.height)
                finalY = rect.y + rect.height - tooltipHeight - 10;
            return [x, finalY];
        }, formatter: function (params) {
            var _a;
            if (Array.isArray(params)) {
                var dateValue = ((_a = params[0]) === null || _a === void 0 ? void 0 : _a.axisValue) || '';
                var firstLine = formatTooltipDateHeader(String(dateValue)) || "".concat(dateValue).concat(getWeekdayLabel(String(dateValue)) ? " ".concat(getWeekdayLabel(String(dateValue))) : '');
                var result_1 = "".concat(firstLine, "<br/>");
                var roomItems_1 = [];
                var priceItems_1 = [];
                params.forEach(function (item) {
                    var _a;
                    var color = item.color;
                    if (item.seriesType === "candlestick" && Array.isArray(item.value)) {
                        var _b = item.value, lowest = _b[2], highest = _b[3];
                        priceItems_1.push({ color: color, lowest: lowest, highest: highest });
                    }
                    else if (item.axisId === "left") {
                        roomItems_1.push({ name: (_a = item.seriesName) !== null && _a !== void 0 ? _a : '', value: item.value, unit: item.unit || "间", color: color });
                    }
                    else {
                        priceItems_1.push({ name: item.seriesName, value: item.value, unit: item.unit || "", color: color });
                    }
                });
                roomItems_1.forEach(function (item) { result_1 += tooltipLine(item.color, "".concat(item.name, ": ").concat(item.value, " ").concat(item.unit)); });
                priceItems_1.forEach(function (item) {
                    var _a, _b, _c;
                    if (item.lowest !== undefined && item.highest !== undefined) {
                        result_1 += tooltipLine(item.color, "\u6700\u4F4E\u4EF7: ".concat(item.lowest, " \u5143"));
                        result_1 += tooltipLine(item.color, "\u6700\u9AD8\u4EF7: ".concat(item.highest, " \u5143"));
                    }
                    else {
                        result_1 += tooltipLine(item.color, "".concat((_a = item.name) !== null && _a !== void 0 ? _a : '', ": ").concat((_b = item.value) !== null && _b !== void 0 ? _b : '', " ").concat((_c = item.unit) !== null && _c !== void 0 ? _c : ''));
                    }
                });
                return result_1;
            }
            else {
                var param = params;
                var dateValue = (param === null || param === void 0 ? void 0 : param.axisValue) || '';
                var firstLine = formatTooltipDateHeader(String(dateValue)) || "".concat(dateValue).concat(getWeekdayLabel(String(dateValue)) ? " ".concat(getWeekdayLabel(String(dateValue))) : '');
                var head = "".concat(firstLine, "<br/>");
                var color = param === null || param === void 0 ? void 0 : param.color;
                if (param.seriesType === "candlestick" && Array.isArray(param.value)) {
                    var _b = param.value, lowest = _b[2], highest = _b[3];
                    return head + tooltipLine(color, "".concat(param.seriesName, "<br/>\u6700\u4F4E\u4EF7: ").concat(lowest, " \u5143<br/>\u6700\u9AD8\u4EF7: ").concat(highest, " \u5143"));
                }
                return head + tooltipLine(color, "".concat(param.seriesName, ": ").concat(param.value, " ").concat(param.unit || ""));
            }
        } }),
};
export var MINI_CHART_SETTINGS = {
    grid: { left: 0, right: 0, top: 0, bottom: 0 },
    xAxis: { show: false },
    yAxis: { show: false },
};
